import React from 'react';
import Header from 'core/Header';
import './core/Header';
import './App.css';
import FunnelItem02 from 'components/FunnelItem02';
import KeyValue from 'components/KeyValue';

function App() {
	return (
		<div className='App'>
			<Header />
			<FunnelItem02
				title='Use Configs 
That Make 
Arc More Fun To Play.'
				displayImage='/logo.png'
				customMarginPadding={{
					applyCustomMargin: true,
					marginTop: '2',
					marginUnits: 'rem',
				}}
			/>
			<h1 className='pt-2 first-item-margin'>Arc Saves</h1>
			<h2 className=''>Game Configs</h2>
			<div className='flex-col retailer-ui-container w-auto pb-2'>
				<h3>The Creative Lite Mode</h3>
				<p>
					Arc Survival Evolved is a large, difficult and grindy game. Many playthoroughs you make tend not to
					go past catching a Pteridon, stegisourous, and a carno. You end up getting stuck on the early game
					because of the sheer time and skill commitment ark asks of you. This is a shame because Arc has a
					lot of content that should be explored. Creative Mode Lite is a set of settings that feels like
					creative mode at time but dosent give you every thing you want when you want it. You get much
					heigher harvest levels, dinasour time times, and level up stat boosts. You will be overpowerd
					durring the early game so feel free to build your base in an ambitios location.
				</p>
				<h4>General</h4>
				<KeyValue keyName='DIFFICULTY LEVEL:' value='1.0' />
				<KeyValue keyName='DINO DAMMAGE:' value='1.0' />
				<KeyValue keyName='PLAYER DAMMAGE:' value='2.0' />
				<KeyValue keyName='STRUCTURE DAMMAGE:' value='1.0' />
				<KeyValue keyName='PLAYER RESISTANCE:' value='1.0' />
				<KeyValue keyName='DINO RESISTANCE:' value='1.0' />
				<KeyValue keyName='STRUCTURE RESISTANCE:' value='1.0' />
				<KeyValue keyName='XP MULTIPLIER:' value='9999' />
				<KeyValue keyName='TAMING SPEED:' value='5.0' />
				<KeyValue keyName='STRUCTURE DMG REPAIR COOLDOWN:' value='180' />
				<KeyValue keyName='DINO TURRET DAMMAGE:' value='1' />
				<KeyValue keyName='DINO HARVESTING DAMMAGE:' value='1' />
				<KeyValue keyName='HARVEST AMOUNT:' value='5.0' />
				<KeyValue keyName='PLAYER CHARACTER WATER DRAIN:' value='0.5' />
				<KeyValue keyName='PLAYER CHARACTER FOOD DRAIN:' value='0.2' />
				<KeyValue keyName='DINO CHARACTER FOOD DRAIN:' value='0.5' />
				<KeyValue keyName='PLAYER CHARACTER STAMINA DRAIN:' value='0.5' />
				<KeyValue keyName='DINO CHARACTER STAMINA DRAIN:' value='0.5' />
				<KeyValue keyName='PLAYER HEALTHE RECOVERY:' value='5.0' />
				<KeyValue keyName='DINO CHARACTER RECOVERY:' value='5.0' />
				<KeyValue keyName='PLAYER HARVESTING DAMAGE:' value='0.5' />
				<KeyValue keyName='DINO COUNT:' value='1.0' />
				<KeyValue keyName='ALLOW THIRD PERSON CAMERA:' value='TRUE' />
				<KeyValue keyName='ENABLE GLOBAL VOICE CHAT:' value='TRUE' />
				<KeyValue keyName='ENABLE CROSSHAIR:' value='TRUE' />
				<KeyValue keyName='SHOW PLAYER LOCATION ON MAP:' value='TRUE' />
				<KeyValue keyName='USE SINGLE PLAYER SETTINGS:' value='TRUE' />
				<KeyValue keyName='USE CORPSE LOCATOR:' value='TRUE' />
				<KeyValue keyName='DISABLE STUCTURE PLACEMENT COLLISION:' value='TRUE' />
				<KeyValue keyName='ALLOW MULTIPLE PLATFORM FLOORS:' value='TRUE' />
				<KeyValue keyName='ALLOW UNLIMITED RESPECTS:' value='TRUE' />
				<KeyValue keyName='SHOW CREATIVE MODE:' value='TRUE' />
				<KeyValue keyName='ALLOW FLYER SPEED LEVELING:' value='TRUE' />
				<h4>Advanced</h4>
				<KeyValue keyName='LAY EGG INTERVAL:' value='0.25' />
				<KeyValue keyName='EGG HATCH SPEED:' value='6' />
				<KeyValue keyName='BABY MATURE SPEED:' value='6.0' />
				<KeyValue keyName='HARVEST HEALTH:' value='3' />
				<KeyValue keyName='DAY CYCLE SPEED:' value='2' />
				<KeyValue keyName='DAY TIME SPEED:' value='1' />
				<KeyValue keyName='NIGHT TIME SPEED:' value='3' />
				<KeyValue keyName='SPOLING TIME:' value='2' />
				<KeyValue keyName='CROP GROWTH SPEED:' value='6.0' />
				<h5>TAMED DINOS STATS PER LEVEL</h5>
				<KeyValue keyName='HEALTH:' value='2.0' />
				<KeyValue keyName='STAMINA:' value='2.0' />
				<KeyValue keyName='TORPIDITY:' value='6.01' />
				<KeyValue keyName='OXYGEN:' value='6.01' />
				<KeyValue keyName='FOOD:' value='6.01' />
				<KeyValue keyName='WATER:' value='6.01' />
				<KeyValue keyName='TEMP:' value='6.01' />
				<KeyValue keyName='WEIGHT:' value='5.00' />
				<KeyValue keyName='DAMAGE:' value='2.0' />
				<KeyValue keyName='SPEED:' value='3.0' />
				<KeyValue keyName='TEMP FORT:' value='6.01' />
				<h5>TAMED DINOS ADD PER LEVEL</h5>
				<KeyValue keyName='HEALTH:' value='2.0' />
				<KeyValue keyName='STAMINA:' value='2.0' />
				<KeyValue keyName='TORPIDITY:' value='6.01' />
				<KeyValue keyName='OXYGEN:' value='6.01' />
				<KeyValue keyName='FOOD:' value='6.01' />
				<KeyValue keyName='WATER:' value='6.01' />
				<KeyValue keyName='TEMP:' value='6.01' />
				<KeyValue keyName='WEIGHT:' value='5.00' />
				<KeyValue keyName='DAMAGE:' value='2.0' />
				<KeyValue keyName='SPEED:' value='1.0' />
				<KeyValue keyName='TEMP FORT:' value='6.01' />
				<h5>TAMED DINOS STATS AFFINITY</h5>
				<KeyValue keyName='HEALTH:' value='2.0' />
				<KeyValue keyName='STAMINA:' value='2.0' />
				<KeyValue keyName='TORPIDITY:' value='2.0' />
				<KeyValue keyName='OXYGEN:' value='2.0' />
				<KeyValue keyName='FOOD:' value='2.0' />
				<KeyValue keyName='WATER:' value='2.0' />
				<KeyValue keyName='TEMP:' value='2.0' />
				<KeyValue keyName='WEIGHT:' value='2.0' />
				<KeyValue keyName='DAMAGE:' value='2.0' />
				<KeyValue keyName='SPEED:' value='2.0' />
				<KeyValue keyName='TEMP FORT:' value='2.0' />
				<h5>PLAYER STATS PER LEVEL</h5>
				<KeyValue keyName='HEALTH:' value='2.0' />
				<KeyValue keyName='STAMINA:' value='2.0' />
				<KeyValue keyName='TORPIDITY:' value='6.01' />
				<KeyValue keyName='OXYGEN:' value='3.5' />
				<KeyValue keyName='FOOD:' value='6.0' />
				<KeyValue keyName='WATER:' value='6.0' />
				<KeyValue keyName='TEMP:' value='6.0' />
				<KeyValue keyName='WEIGHT:' value='5.0' />
				<KeyValue keyName='DAMAGE:' value='2.0' />
				<KeyValue keyName='SPEED:' value='3.0' />
				<KeyValue keyName='TEMP FORT:' value='5.0' />
				<h5>EXPERIENCE MULTIPLIERS</h5>
				<KeyValue keyName='GENERIC:' value='6.0' />
				<KeyValue keyName='KILL:' value='6.0' />
				<KeyValue keyName='HARVEST:' value='6.0' />
				<KeyValue keyName='CRAFT:' value='6.0' />
				<KeyValue keyName='SPECIAL:' value='6.0' />
				<h5>MISCELLANEOUS SETTINGS</h5>
				<KeyValue keyName='SUPPLY CREATE LOOT QUALITY:' value='' />
				<KeyValue keyName='FUEL CONSUMPTION INTERVAL MULTIPLIER:' value='' />
			</div>
		</div>
	);
}

export default App;
